/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Glyphicon} from "../../GlyphIcon";
import React from "react";

export function EditItemButton(props) {
    const {
        show = true,
        onEdit = () => {},
        className = '',
    } = props;

    if(!show) { return null; }

    return <div className={['edit-table', className].filter(Boolean).join(' ')}>
        <a onClick={() => onEdit()} className="sb-permit-edit-btn">
            <Glyphicon glyph="pencil"/>
        </a>
    </div>;
}
